export default {
  // Page title
  title: "Change Password",

  // Form labels
  password: "Password",
  confirmPassword: "Confirm Password",

  // Buttons
  cancel: "Cancel",
  modifyPassword: "Change Password",

  // Validation messages
  pleaseEnterPassword: "Please enter password",
  pleaseConfirmPassword: "Please confirm password",
  passwordMismatch: "Passwords do not match!",

  // Success message
  modifySuccess: "Password changed successfully",
};
